import { resetValue } from './constants';

// Styles fallback for browsers that don't support `all` property.
const properties = [
  'alignContent',
  'alignItems',
  'alignSelf',
  'animationDelay',
  'animationDirection',
  'animationDuration',
  'animationFillMode',
  'animationIterationCount',
  'animationName',
  'animationPlayState',
  'animationTimingFunction',
  'appearance',
  'mozAppearance',
  'msAppearance',
  'webkitAppearance',
  'backfaceVisibility',
  'backgroundAttachment',
  'backgroundBlendMode',
  'backgroundClip',
  'backgroundColor',
  'backgroundImage',
  'backgroundOrigin',
  'backgroundPosition',
  'backgroundRepeat',
  'backgroundSize',
  'borderBottomColor',
  'borderBottomLeftRadius',
  'borderBottomRightRadius',
  'borderBottomStyle',
  'borderBottomWidth',
  'borderCollapse',
  'borderLeftColor',
  'borderLeftStyle',
  'borderLeftWidth',
  'borderRightColor',
  'borderRightStyle',
  'borderRightWidth',
  'borderSpacing',
  'borderTopColor',
  'borderTopLeftRadius',
  'borderTopRightRadius',
  'borderTopStyle',
  'borderTopWidth',
  'bottom',
  'boxShadow',
  'boxSizing',
  'clear',
  'clip',
  'clipPath',
  'color',
  'columnCount',
  'columnFill',
  'columnGap',
  'columnRuleColor',
  'columnRuleStyle',
  'columnRuleWidth',
  'columnSpan',
  'columnWidth',
  'content',
  'counterIncrement',
  'counterReset',
  'cursor',
  'display',
  'filter',
  'flexBasis',
  'flexDirection',
  'flexGrow',
  'flexShrink',
  'flexWrap',
  'float',
  'fontFamily',
  'fontFeatureSettings',
  'fontKerning',
  'fontLanguageOverride',
  'fontSize',
  'fontSizeAdjust',
  'fontStretch',
  'fontStyle',
  'fontVariant',
  'fontVariantAlternates',
  'fontVariantCaps',
  'fontVariantEastAsian',
  'fontVariantLigatures',
  'fontVariantNumeric',
  'fontVariantPosition',
  'fontWeight',
  'gridAutoColumns',
  'gridAutoFlow',
  'gridAutoRows',
  'gridColumnEnd',
  'gridColumnGap',
  'gridColumnStart',
  'gridRowEnd',
  'gridRowGap',
  'gridRowStart',
  'gridTemplateAreas',
  'gridTemplateColumns',
  'gridTemplateRows',
  'height',
  'hyphens',
  'inlineSize',
  'isolation',
  'justifyContent',
  'left',
  'letterSpacing',
  'lineBreak',
  'lineHeight',
  'listStyleImage',
  'listStylePosition',
  'listStyleType',
  'marginBottom',
  'marginLeft',
  'marginRight',
  'marginTop',
  'maxHeight',
  'maxWidth',
  'minHeight',
  'minWidth',
  'mixBlendMode',
  'objectFit',
  'opacity',
  'order',
  'orphans',
  'outlineColor',
  'outlineStyle',
  'outlineWidth',
  'overflow',
  'overflowWrap',
  'overflowX',
  'overflowY',
  'paddingBottom',
  'paddingLeft',
  'paddingRight',
  'paddingTop',
  'perspective',
  'perspectiveOrigin',
  'pointerEvents',
  'position',
  'quotes',
  'resize',
  'right',
  'scrollBehavior',
  'scrollSnapCoordinate',
  'scrollSnapDestination',
  'scrollSnapPointsX',
  'scrollSnapPointsY',
  'scrollSnapType',
  'textAlign',
  'textAlignLast',
  'textDecoration',
  'textIndent',
  'textShadow',
  'textTransform',
  'top',
  'transform',
  'transformOrigin',
  'transitionDelay',
  'transitionDuration',
  'transitionProperty',
  'transitionTimingFunction',
  'verticalAlign',
  'visibility',
  'whiteSpace',
  'width',
  'willChange',
  'wordBreak',
  'wordSpacing',
  'wordWrap',
  'zIndex',
];

type ResetObj = {
  [cssProperty: string]: string;
};

// Sets all `properties` values to `resetValue`.
// Mutates `resetObject` to avoid creating a ton of instant
// garbage objects during the `reduce`.
export default properties.reduce((resetObj: ResetObj, property: string) => {
  resetObj[property] = resetValue;
  return resetObj;
}, {});
